module.exports = __webpack_public_path__ + "static/don35-f811979d69c81d455ddf85560bf32a34.jpg";